import { connect } from 'react-redux';
import { contactSubmit } from 'website/website.actions';
import { getEmail } from 'website/website.selectors';
import Contact from 'components/Contact';

function mapDispatchToProps(dispatch) {
  return {
    onSubmit: data => dispatch(contactSubmit(data))
  };
}

function mapStateToProps(state) {
  return {
    confirm: state.website.contactConfirm,
    email: getEmail(state),
    color: state.website.color
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Contact);


// WEBPACK FOOTER //
// ./src/containers/Contact.container.js